import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.jsx';
import { applyServerReturnPath } from './serverReturnPath.js';
// The shared Lantern token stylesheet. It must load before the components mount, because each
// recovered component injects its own scoped CSS that reads these custom properties and falls back
// to a literal when one is missing. Importing it here is what stops the fallbacks being used.
import './styles/index.css';

// BEFORE the router mounts, and that ordering is the point.
//
// `server/auth/routes/google.routes.js` hands the browser back at PATHS with query strings —
// `/login?error=oauth_denied`, `/signup?google=1`. `App.jsx` mounts a HashRouter, which reads only
// the part after `#`, so every one of those reasons was silently dropped (#543). Translating here
// means the router mounts on an address it can actually read, rather than being told to navigate
// after it has already resolved the default route.
//
// It is fixed on this side because production still serves the PATH-routed app at the same
// APP_URL: rewriting the server's targets would fix dev by breaking production.
applyServerReturnPath();

const container = document.getElementById('root');
if (!container) throw new Error('missing #root mount point');

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
